import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';
import App from './App';
import { ThemeProvider } from './theme/ThemeContext';
import './index.css';

// Initialise Sentry only if REACT_APP_SENTRY_DSN is set at build time.
// Set the variable in Vercel → Project Settings → Environment Variables.
const SENTRY_DSN = process.env.REACT_APP_SENTRY_DSN;
if (SENTRY_DSN) {
  Sentry.init({
    dsn: SENTRY_DSN,
    environment: process.env.NODE_ENV,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.0,           // performance tracing off; enable later if useful
    sendDefaultPii: false,           // don't auto-capture IPs / cookies
    beforeSend(event) {
      // Drop sensitive query strings just in case
      if (event.request?.url) {
        event.request.url = event.request.url.replace(/([?&])(token|access_token|refresh_token)=[^&]*/gi, '$1$2=REDACTED');
      }
      return event;
    },
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </BrowserRouter>
  </React.StrictMode>
);